// removed by extract-text-webpack-plugin
module.exports = {"parts":"_2QhXD","part":"_3RQin","active":"_1RdJU"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/SectionHeader/styles.css
 ** module id = 346
 ** module chunks = 0
 **/